import { render, staticRenderFns } from "./ConfirmPopup.vue?vue&type=template&id=00b8cbbd"
import script from "./ConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./ConfirmPopup.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmPopup.vue?vue&type=style&index=0&id=00b8cbbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VIcon,VSpacer})
